<div class="ms-1 pb-3">
  <div>
    <strong>STATUS</strong>
    <p>{{ capture.status | captureStatus }}</p>
  </div>
  @if (reason) {
    <div>
      <strong>REASONS</strong>
      <ul class="ps-4">
        <li class="py-1">{{ reason.display }}</li>
      </ul>
    </div>
  }
  @if (patientPrescriberNote?.active) {
    <div>
      <strong>NOTES FOR REFERRAL AND CONSULT NOTE TASKS</strong>
      <div class="bg-light border px-2 mt-2 mb-3">
        <app-note [note]="patientPrescriberNote" />
      </div>
    </div>
  }
  @if (verificationOutcome.additionalDetails) {
    <div>
      <strong>ADDITIONAL DETAILS</strong>
      <p>{{ verificationOutcome.additionalDetails }}</p>
    </div>
  }
</div>
